import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const IMAGEANDCALLTOACTIONSBLOCK_LEGACY_FIELD_ORDER = [
  "anchor",
  "image_position",
  "image",
  "text_on_image",
  "url_button_image",
  "label_button_image",
  "button-size-y",
  "text_content"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  imageAndCallToActionsBlockDescriptor: _generatedImageAndCallToActionsBlockDescriptor,
  imageAndCallToActionsBlockBlocDefinition,
  imageAndCallToActionsBlockDashboardLayout,
  imageAndCallToActionsBlockConfig,
  imageAndCallToActionsBlockResolveConfig,
  imageAndCallToActionsBlockProperties,
} = doodBlockConfig(
  {
    name: "Image and call to actions",
    componentType: 'ImageAndCallToActionsBlockComponent',
    category: 'content',
    description: "Image and call to actions.",
    keywords: [],
    hideFromPicker: true,
    sharedFields: {},
    slots: [
      {
        key: 'buttons',
        name: "pages.blocks.image-and-call-to-actions.buttons.label",
        accept: 'explicitOnly',
        allowedTypes: ["ButtonBlock"],
        slotItemFormat: 'ids',
      }
    ]
  },

  () => ({
    anchor: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.image-and-call-to-actions.anchor.label",
        help: "pages.blocks.image-and-call-to-actions.anchor.help",
      }
    }),
    image_position: propertyValue({
      type: 'select',
      value: "left",
      options: {
        label: "pages.blocks.image-and-call-to-actions.image-position.label",
        multiple: false,
        choices: [
          {
            value: "left",
            label: "pages.blocks.image-and-call-to-actions.image-position.options.left",
          },
          {
            value: "right",
            label: "pages.blocks.image-and-call-to-actions.image-position.options.right",
          },
        ],
      }
    }),
    image: propertyValue({
      type: 'image',
      value: '',
      options: {
        label: "pages.blocks.image-and-call-to-actions.image.label",
        help: "pages.blocks.image-and-call-to-actions.image.help",
      }
    }),
    text_on_image: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.image-and-call-to-actions.text-on-image.label",
      }
    }),
    url_button_image: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.image-and-call-to-actions.url-button-image.label",
        help: "pages.blocks.image-and-call-to-actions.url-button-image.help",
      }
    }),
    label_button_image: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.image-and-call-to-actions.label-button-image.label",
      }
    }),
    "button-size-y": propertyValue({
      type: 'select',
      value: "M",
      options: {
        label: "pages.blocks.image-and-call-to-actions.button-size-y.label",
        multiple: false,
        choices: [
          {
            value: "S",
            label: "pages.blocks.image-and-call-to-actions.button-size-y.options.S",
          },
          {
            value: "M",
            label: "pages.blocks.image-and-call-to-actions.button-size-y.options.M",
          },
          {
            value: "L",
            label: "pages.blocks.image-and-call-to-actions.button-size-y.options.L",
          },
        ],
      }
    }),
    text_content: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.image-and-call-to-actions.text-content.label",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.image-and-call-to-actions.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.image-and-call-to-actions.fieldset.layout.label",
            fields: ["anchor", "image_position"],
          },
          {
            legend: "pages.blocks.image-and-call-to-actions.fieldset.image.label",
            fields: ["image", "text_on_image"],
          },
          {
            legend: "pages.blocks.image-and-call-to-actions.fieldset.image-button.label",
            fields: ["label_button_image", "url_button_image", "button-size-y"],
          },
          {
            legend: "pages.blocks.image-and-call-to-actions.fieldset.side-content.label",
            fields: ["text_content", "buttons"],
          },
        ],
      },
    ],
  })
);

export function imageAndCallToActionsBlockDescriptor(): IBlockDescriptor;
export function imageAndCallToActionsBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function imageAndCallToActionsBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedImageAndCallToActionsBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedImageAndCallToActionsBlockDescriptor, imageAndCallToActionsBlockProperties, fieldOrder);
}

export {
  imageAndCallToActionsBlockBlocDefinition,
  imageAndCallToActionsBlockDashboardLayout,
  imageAndCallToActionsBlockProperties,
  imageAndCallToActionsBlockConfig,
  imageAndCallToActionsBlockResolveConfig,
};

export type ImageAndCallToActionsBlockConfig = typeof imageAndCallToActionsBlockConfig;
